import graphql__56b45b44e143bdd289c2 from "./__generated__/CreateCustomerDialogMutation.graphql.ts";import * as React from "react";
import {commitMutation, graphql} from "react-relay";
import Section from "../form/Section";
import Field from "../form/Field";
import Row from "../form/Row";
import Label from "../form/Label";
import Hint from "../presentational/Hint";
import * as yup from "yup";
import FormDialog from "../dialog/FormDialog";
import type {CreateCustomerDialogMutation} from "./__generated__/CreateCustomerDialogMutation.graphql";
import {useNavigate} from "react-router-dom";
import {useRelayEnvironment} from "react-relay/hooks";
import {commitMutationWithErrorHandling} from "../../helper/commitMutationWithErrorHandling";
import {useErrorContext} from "../../contexts/ErrorContext";
import {useIntl} from "react-intl";

type Props = {
    handleCloseDialog: () => {}
}

const CreateCustomerDialog: React.FC<Props> = ({handleCloseDialog}) => {
    const intl = useIntl();
    const relayEnvironment = useRelayEnvironment();
    const navigate = useNavigate();
    const {addError} = useErrorContext();

    const handleSubmission = (input) => {
        commitMutationWithErrorHandling<CreateCustomerDialogMutation>(
            relayEnvironment,
            {
                mutation: graphql__56b45b44e143bdd289c2,
                variables: {
                    input: input
                },
                onCompleted: (response, errors) => {
                    if (errors && errors.length > 0) {
                        console.error(errors);
                    }
                    handleCloseDialog();
                    navigate('/customers/' + response.createCustomerAccount?.id)
                },
                onError: (error) => {
                    console.error(error);
                    handleCloseDialog();
                }
            },
            addError,
            {
                customErrorMessage: intl.formatMessage({id: 'errors.failedToCreateCustomer'})
            }
        )
    }
    const validationSchema = yup.object().shape({
        customerName: yup.string()
            .min(2, intl.formatMessage({id: 'validation.field.nameTooShort'}))
            .max(255, intl.formatMessage({id: 'validation.field.nameTooLong'}))
            .required(intl.formatMessage({id: 'validation.field.required'})),
    });

    return (
        <FormDialog handleCloseDialog={handleCloseDialog} handleSubmission={handleSubmission} initialValues={{}} validationSchema={validationSchema} headline={intl.formatMessage({id: 'dialog.CreateCustomerDialog.headline'})} submitLabel={intl.formatMessage({id: 'button.create'})}>
            <Section>
                <Row>
                    <Label>{intl.formatMessage({id: 'dialog.CreateCustomerDialog.customerNameLabel'})}</Label>
                    <Field name="customerName" type="text" placeholder={intl.formatMessage({id: 'dialog.CreateCustomerDialog.customerNamePlaceholder'})} autoFocus={true}/>
                </Row>
                <Row><Hint>{intl.formatMessage({id: 'dialog.CreateCustomerDialog.hint'})}</Hint></Row>
            </Section>
        </FormDialog>
    )
}

export default CreateCustomerDialog;
